import { ApiParameter, get } from "@insite/client-framework/Services/ApiService";
import { DepartmentModel } from "@tCooneyBrothers/ApiModels";

const departmentUrl = "api/v1/SystemListValues";

export function getDepartments() {
    return get<DepartmentModel[]>(`${departmentUrl}`, {});
}

export interface GetDepartmentApiParameter extends ApiParameter {
    id?: string;
    description: string;
}
